import React, { useState, useContext } from 'react';
import axios from 'axios';
import backendUrl from '../BackendUrl';
import { UserContext } from '../context/UserContext';
import '../styles/ContactUs.css';

const ContactUs = () => {
  const { user } = useContext(UserContext);

  // Always call hooks at the top level
  const [subject, setSubject] = useState('');
  const [vehicle, setVehicle] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState('');
  const [submitting, setSubmitting] = useState(false);

  // Only allow signed-in users
  if (!user) {
    return <div>Please sign in to contact us.</div>;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setStatus('');
    try {
      const inquiry = {
        name: `${user.firstName} ${user.lastName}`,
        email: user.email,
        subject,
        vehicle,
        message,
        date: new Date().toISOString(),
      };
      await axios.post(`${backendUrl}/api/accounts/contact`, inquiry, {
        headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` }
      });
      setStatus('Your inquiry has been sent. We will get back to you soon!');
      setSubject('');
      setVehicle('');
      setMessage('');
    } catch (err) {
      setStatus('Failed to send inquiry. Please try again later.');
    }
    setSubmitting(false);
  };

  return (
    <div className="contact-us-container">
      <h1>Contact Us</h1>
      <form className="contact-form" onSubmit={handleSubmit}>
        <div>
          <label>Name:</label>
          <input type="text" value={`${user.firstName} ${user.lastName}`} disabled />
        </div>
        <div>
          <label>Email:</label>
          <input type="email" value={user.email} disabled />
        </div>
        <div>
          <label>Date/Time:</label>
          <input type="text" value={new Date().toLocaleString()} disabled />
        </div>
        <div>
          <label>Subject:</label>
          <input
            type="text"
            value={subject}
            onChange={e => setSubject(e.target.value)}
            required
            placeholder="Subject of your inquiry"
          />
        </div>
        <div>
          <label>Vehicle of Interest:</label>
          <input
            type="text"
            value={vehicle}
            onChange={e => setVehicle(e.target.value)}
            placeholder="(Optional) Vehicle model or class"
          />
        </div>
        <div>
          <label>Message:</label>
          <textarea
            value={message}
            onChange={e => setMessage(e.target.value)}
            required
            placeholder="Type your message here..."
            rows={5}
          />
        </div>
        <button type="submit" disabled={submitting}>
          {submitting ? 'Sending...' : 'Send Inquiry'}
        </button>
        {status && <div className="contact-status">{status}</div>}
      </form>
    </div>
  );
};

export default ContactUs;